const postUserAvailabilityPayload = (data) => {
  const payload = { ...data };

  return payload;
};

export default postUserAvailabilityPayload;
